"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
const flatbuffers = require("flatbuffers");
class AccountMetadataTransactionBuffer {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsAccountMetadataTransactionBuffer(bb, obj) {
        return (obj || new AccountMetadataTransactionBuffer()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsAccountMetadataTransactionBuffer(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new AccountMetadataTransactionBuffer()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    size() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    signature(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    signatureLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    signatureArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    signer(index) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    signerLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    signerArray() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    version() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    type() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    maxFee(index) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    maxFeeLength() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    maxFeeArray() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    deadline(index) {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    deadlineLength() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    deadlineArray() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    targetKey(index) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    targetKeyLength() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    targetKeyArray() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    scopedMetadataKey(index) {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    scopedMetadataKeyLength() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    scopedMetadataKeyArray() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    valueSizeDelta() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.readInt16(this.bb_pos + offset) : 0;
    }
    valueSize() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    value(index) {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    valueLength() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    valueArray() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    static startAccountMetadataTransactionBuffer(builder) {
        builder.startObject(13);
    }
    static addSize(builder, size) {
        builder.addFieldInt32(0, size, 0);
    }
    static addSignature(builder, signatureOffset) {
        builder.addFieldOffset(1, signatureOffset, 0);
    }
    static createSignatureVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startSignatureVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addSigner(builder, signerOffset) {
        builder.addFieldOffset(2, signerOffset, 0);
    }
    static createSignerVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startSignerVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addVersion(builder, version) {
        builder.addFieldInt32(3, version, 0);
    }
    static addType(builder, type) {
        builder.addFieldInt16(4, type, 0);
    }
    static addMaxFee(builder, maxFeeOffset) {
        builder.addFieldOffset(5, maxFeeOffset, 0);
    }
    static createMaxFeeVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startMaxFeeVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addDeadline(builder, deadlineOffset) {
        builder.addFieldOffset(6, deadlineOffset, 0);
    }
    static createDeadlineVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startDeadlineVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addTargetKey(builder, targetKeyOffset) {
        builder.addFieldOffset(7, targetKeyOffset, 0);
    }
    static createTargetKeyVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startTargetKeyVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addScopedMetadataKey(builder, scopedMetadataKeyOffset) {
        builder.addFieldOffset(8, scopedMetadataKeyOffset, 0);
    }
    static createScopedMetadataKeyVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startScopedMetadataKeyVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addValueSizeDelta(builder, valueSizeDelta) {
        builder.addFieldInt16(9, valueSizeDelta, 0);
    }
    static addValueSize(builder, valueSize) {
        builder.addFieldInt16(10, valueSize, 0);
    }
    static addValue(builder, valueOffset) {
        builder.addFieldOffset(11, valueOffset, 0);
    }
    static createValueVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startValueVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static endAccountMetadataTransactionBuffer(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static finishAccountMetadataTransactionBufferBuffer(builder, offset) {
        builder.finish(offset);
    }
    static finishSizePrefixedAccountMetadataTransactionBufferBuffer(builder, offset) {
        builder.finish(offset, undefined, true);
    }
    static createAccountMetadataTransactionBuffer(builder, size, signatureOffset, signerOffset, version, type, maxFeeOffset, deadlineOffset, targetKeyOffset, scopedMetadataKeyOffset, valueSizeDelta, valueSize, valueOffset) {
        AccountMetadataTransactionBuffer.startAccountMetadataTransactionBuffer(builder);
        AccountMetadataTransactionBuffer.addSize(builder, size);
        AccountMetadataTransactionBuffer.addSignature(builder, signatureOffset);
        AccountMetadataTransactionBuffer.addSigner(builder, signerOffset);
        AccountMetadataTransactionBuffer.addVersion(builder, version);
        AccountMetadataTransactionBuffer.addType(builder, type);
        AccountMetadataTransactionBuffer.addMaxFee(builder, maxFeeOffset);
        AccountMetadataTransactionBuffer.addDeadline(builder, deadlineOffset);
        AccountMetadataTransactionBuffer.addTargetKey(builder, targetKeyOffset);
        AccountMetadataTransactionBuffer.addScopedMetadataKey(builder, scopedMetadataKeyOffset);
        AccountMetadataTransactionBuffer.addValueSizeDelta(builder, valueSizeDelta);
        AccountMetadataTransactionBuffer.addValueSize(builder, valueSize);
        AccountMetadataTransactionBuffer.addValue(builder, valueOffset);
        return AccountMetadataTransactionBuffer.endAccountMetadataTransactionBuffer(builder);
    }
}
exports.AccountMetadataTransactionBuffer = AccountMetadataTransactionBuffer;
//# sourceMappingURL=AccountMetadataTransactionBuffer.js.map